<section>
  <app-breadcrumb [label]="labelBreadcrumb" [labels]="breadcrumbLabels"></app-breadcrumb>

  <div class="section__main section__main--reports">
    <div class="section__title pb-15">
      <h1>Reporte de cierre (créditos WOM)</h1>
    </div>

    <div class="reports">
      <!-- Summary cards -->
      <app-closing-report-summary-cards class="reports__cardsComp" [summaryCards]="summaryCards"></app-closing-report-summary-cards>

      <!-- Credits table section -->
      <app-closing-report-credits-table
        class="reports__tableComp"
        [records]="allRecords"
        (rowClick)="openCertificateModal($event)"
        (downloadPdf)="downloadPdf($event)"
        (dateFilterChange)="onDateFilterChange($event)"
        (clearDateFilter)="onClearDateFilter()"
      ></app-closing-report-credits-table>
    </div>
  </div>
</section>

<!-- Generador PDF -->
<div class="certificado-print-host" aria-hidden="true">
  <div #certificatePdfContent class="certificado-print">
    <app-closing-report-certificate [detail]="certificateDetail" [isPdf]="true" [showActions]="false" [logoSvg]="certificateLogoSvg"></app-closing-report-certificate>
  </div>
</div>

<!-- Modal Certificado-->
<p-dialog [(visible)]="showCertificateModal" [modal]="true" [dismissableMask]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom" class="especial__modal">
  <app-closing-report-certificate [detail]="certificateDetail" [isPdf]="false"  [showActions]="true"  [isGeneratingPdf]="isGeneratingPdf"  [isLoadingCertificateDetail]="isLoadingCertificateDetail"  (close)="closeCertificateModal()"  (exportPdf)="exportCertificatePdf()"></app-closing-report-certificate>
</p-dialog>
